import { render, staticRenderFns } from "./SkillActionBar.vue?vue&type=template&id=6f58258a&scoped=true"
import script from "./SkillActionBar.vue?vue&type=script&lang=js"
export * from "./SkillActionBar.vue?vue&type=script&lang=js"
import style0 from "./SkillActionBar.vue?vue&type=style&index=0&id=6f58258a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58258a",
  null
  
)

export default component.exports